import React from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Typography, Row, Col, Tabs, Button } from "antd";
import { useHistory, useParams } from "react-router-dom";
import * as taxCollectionActions from "../../../../actionCreators/TaxCollection";
import PopupModal from "../../../../Components/PopupModal";
import TaxProperties from "./TaxProperties";
import PaidProperties from "./PaidProperties";
import PendingProperties from "./PendingProperties";
import PropertyPhTenPdf from "../Properties/Forms/PropertyPhTenPdf";
import "./style/surveyListing.css";
import "../../style/index.css";
const { TabPane } = Tabs;

const TaxCollectionListing = ({
  user,
  getTaxCollectionsList,
  getTaxPropertiesList,
}) => {
  const history = useHistory();
  const { id } = useParams();
  const [isInspector, setIsInspector] = React.useState(true);
  const [showWarning, setShowWarning] = React.useState(false);
  const [selected, setSelected] = React.useState(false);
  const [selectedData, setSelectedData] = React.useState(null);
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    if (user) {
      setIsInspector(
        user.currentUser.data.user_roles.findIndex((e) => e.role_id == 1) >= 0
      );
    }
  }, [user]);
  const onTabChange = (key) => {
    if (key === "create") {
      getTaxPropertiesList({ page: 0, pageSize: 10});
      history.push("/tax-collection/" + key);
    } else if (key === "challans") {
      getTaxCollectionsList({ page: 0, pageSize: 10, type: "challans" });
      history.push("/tax-collection/" + key);
    } else if (key === "pending") {
      getTaxCollectionsList({ page: 0, pageSize: 10, type: "pending" });
      history.push("/tax-collection/" + key);
    }
  };
  const handleRowSelection = (selected, data) => {
    setSelected(selected);
    setSelectedData(data);
  };
  const handleBulkPrinting = () => {
    if (selected === true) {
      let selectedDataIds = [];
      for (let i = 0; i < selectedData.length; i++) {
        selectedDataIds = [...selectedDataIds, { id: selectedData[i].id }];
      }
      history.push("/bulkph10", { data: selectedDataIds });
    } else {
      setShowWarning(true);
    }
  };

  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <Typography className="heading">Tax Collection</Typography>
        </div>
        {id === "challans"  ? (
          <div
            style={{
              padding: "7px 18px",
              background: "#284F68",
              color: "white",
              borderRadius: "5px",
              fontWeight: "500",
              fontSize: "15px",
              cursor: "pointer",
              marginRight: "8px",
            }}
            onClick={handleBulkPrinting}
          >
            Bulk Generate PH10
          </div>
        ) : (
          <></>
        )}
      </div>
      <Tabs className="tab-main" defaultActiveKey={id} onChange={onTabChange}>
        {isInspector && (
          <TabPane tab="CREATE CHALLAN" key="create" className="tab-pane">
            <TaxProperties />
          </TabPane>
        )}

        <TabPane tab="CHALLANS" key="challans" className="tab-pane">
          <PaidProperties handleSelectedData={handleRowSelection} />
        </TabPane>
        <TabPane tab="PENDING APPROVAL" key="pending" className="tab-pane">
          <PendingProperties />
        </TabPane>
      </Tabs>
      <PopupModal
        title={"No Property Selected"}
        centered
        visible={showWarning}
        onCancel={() => setShowWarning(false)}
        footer={[
          <Button
            key="submit"
            type="link"
            onClick={() => {
              setShowWarning(false);
            }}
          >
            OK
          </Button>,
        ]}
      >
        Please select one/more properties to print PH10 form.
      </PopupModal>
    </React.Fragment>
  );
};
const mapStateToProps = ({ user: user }) => ({ user });
// export default TaxCollectionListing;
const mapDispatchToProps = (dispatch) => ({
  getTaxCollectionsList: bindActionCreators(
    taxCollectionActions.getTaxCollectionsList,
    dispatch
  ),
  getTaxPropertiesList: bindActionCreators(
    taxCollectionActions.getTaxPropertiesList,
    dispatch
  ),
});

TaxCollectionListing.propTypes = {
  // taxCollectionsList: PropTypes.object.isRequired,
  getTaxCollectionsList: PropTypes.func.isRequired,
  getTaxPropertiesList: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TaxCollectionListing);
